const fetch = require("node-fetch");

const ACCESSIBLE_MESSAGE = "URL is accessible.";
const ERROR_RESPONSE_MESSAGE = "The server returned an error.";
const UNKNOWN_REASON_MESSAGE = "Unable to access the URL, it is probably a wrong url";
const DNS_ERROR_MESSAGE = "DNS error Unable to resolve the hostname.";
const TOPIC = "Destination link is not correct";

/**
 * Validates the accessibility of a destination link and sends messages accordingly.
 * Some destination links won't get approved by google ads, so we need to check them manually.
 * That is the resposnible of this function.
 *
 * @param {Object} params - The params object.
 * @param {string} params.url - The destination URL to be validated.
 * @param {(message: string) => Promise<void>} params.sendFrontMessage - The function to send messages to the front end.
 * @param {(message: string) => Promise<void>} params.sendSlackMessage - The function to send messages to Slack.
 * @returns {string} The validation result message.
 */
async function validateDestinationLink({ url, sendFrontMessage, sendSlackMessage }) {
  let message = UNKNOWN_REASON_MESSAGE;

  try {
    const response = await fetch(url, { method: "HEAD" });

    if (response.ok) {
      message = ACCESSIBLE_MESSAGE;
    }

    const { status } = response;
    const isHTTPError = status >= 400 && status < 600;

    if (isHTTPError) {
      message = `HTTP ${status} response: ${ERROR_RESPONSE_MESSAGE}`;
    }
  } catch (error) {
    if (
      error.name === "FetchError" &&
      error.type === "system" &&
      error.message.includes("ENOTFOUND")
    ) {
      message = DNS_ERROR_MESSAGE;
    }
  } finally {
    if (message !== ACCESSIBLE_MESSAGE) {
      sendSlackMessage({ topic: TOPIC, message });
      sendFrontMessage({
        message: `${TOPIC}, campaign can be disapproved. Link error: ${message} Please check it manually`
      });
    }
  }

  return message;
}

module.exports = {
  validateDestinationLink,
  ACCESSIBLE_MESSAGE,
  ERROR_RESPONSE_MESSAGE,
  UNKNOWN_REASON_MESSAGE,
  DNS_ERROR_MESSAGE,
  TOPIC
};
